
export default {
  async asyncData ({ $content }) {
    const legal = await $content('Legal', {
      deep: true
    }).fetch()

    return {
      legal
    }
  }
}
